// App.jsx
import { useEffect, useState, useCallback } from "react";

import { Filemanager } from "@svar-ui/react-filemanager";
import "@svar-ui/react-filemanager/all.css";
import { Willow } from "@svar-ui/react-filemanager";

import { useDispatch } from 'react-redux'
import { fetchFiles } from '../lib/store/userdata.js';

const getLink = (id, mode) => `/api/files/${mode}?id=` + encodeURIComponent(id);

export default function FileBrowser() {
  const dispatch = useDispatch();

  const [ data, setData ] = useState([]);

  const runFetchFiles = useCallback(async function () {
    const resp = await dispatch(fetchFiles());
    if (resp.error) {
      console.error('Error fetching files');
    }
    else {
      setData(resp.payload)
    }
  }, [dispatch]);

  useEffect(() => {
    runFetchFiles()
      .catch((e) => {
        console.error ("Error while fetching files", e)
      })
  }, [runFetchFiles])

  const init = (api) => {
    api.on("download-file", (ev) => {
      window.open(getLink(ev.id, 'download'), "_blank");
    });
    
    api.on("open-file", (ev) => {
      window.open(getLink(ev.id, 'open'), "_blank");
    });
    
    api.on("request-data", async ({ id }) => {
      console.log ('Request data', id)
      await runFetchFiles();
    });
  };
  
  return (
    <Willow>
      <Filemanager init={init} data={data} mode="table" readonly={true}/>
    </Willow>
  );
}
